import { createAsyncThunk } from "@reduxjs/toolkit";
import { postData } from "../../../apiservice/apis";

export const fetchManufacturers = createAsyncThunk(
    'cuttingLogic/fetchManufacturers',
    async (_, thunkAPI) => {
        try {
            const res = await postData('/purchase/manufacturing-companies', {});
            return res.data.data;
        } catch (error) {
            console.error('❌ Fetch manufacturers error:', error);
            return thunkAPI.rejectWithValue(
                error.response?.data?.message || 
                error.response?.data || 
                error.message || 
                "Failed to fetch manufacturers"
            );
        }
    }
);

export const fetchCuttingLogic = createAsyncThunk(
    'cuttingLogic/fetchLogic',
    async (_, thunkAPI) => {
        try {
            const res = await postData('/purchase/get-cutting-logic', {});
            return res.data.data || [];
        } catch (error) {
            console.error('❌ Fetch cutting logic error:', error);
            return thunkAPI.rejectWithValue(
                error.response?.data?.message || 
                error.response?.data || 
                error.message || 
                "Failed to fetch cutting logic"
            );
        }
    }
);

export const saveCuttingLogic = createAsyncThunk(
    'cuttingLogic/save',
    async (payload, thunkAPI) => {
        try {
            console.log('📤 Saving with payload:', payload);
            const res = await postData('/purchase/save-cutting-logic', payload);
            console.log('✅ Save response:', res);
            return res.data;
        } catch (error) {
            console.error('❌ Save error:', error);
            
            // Extract detailed error message from backend
            let errorMessage = "Failed to save. Please try again.";
            
            if (error.response?.data) {
                // If backend returns { status: false, message: "..." }
                if (error.response.data.message) {
                    errorMessage = error.response.data.message;
                } else if (typeof error.response.data === 'string') {
                    errorMessage = error.response.data;
                }
            } else if (error.message) {
                errorMessage = error.message;
            }
            
            return thunkAPI.rejectWithValue(errorMessage);
        }
    }
);

export const deleteCuttingLogic = createAsyncThunk(
    'cuttingLogic/delete',
    async (id, thunkAPI) => {
        try {
            const res = await postData('/purchase/delete-cutting-logic', { id });
            return res.data;
        } catch (error) {
            console.error('❌ Delete error:', error);
            
            let errorMessage = "Failed to delete. Please try again.";
            
            if (error.response?.data?.message) {
                errorMessage = error.response.data.message;
            } else if (error.response?.data && typeof error.response.data === 'string') {
                errorMessage = error.response.data;
            } else if (error.message) {
                errorMessage = error.message;
            }
            
            return thunkAPI.rejectWithValue(errorMessage);
        }
    }
);